import z from 'zod';
import { FieldAdapter } from '@mews-framework/form';
import { Validation } from '@mews-framework/form/validation';
import { CalendarService, StructuredDate, WithFocusTrapProps } from '@optimus-web/core';

export enum DatePeriod {
    Today = 'Today',
    Yesterday = 'Yesterday',
    Tomorrow = 'Tomorrow',
    ThisWeek = 'ThisWeek',
    LastWeek = 'LastWeek',
    NextWeek = 'NextWeek',
    ThisMonth = 'ThisMonth',
    LastMonth = 'LastMonth',
    NextMonth = 'NextMonth',
    ThisQuarter = 'ThisQuarter',
    LastQuarter = 'LastQuarter',
    NextQuarter = 'NextQuarter',
    ThisYear = 'ThisYear',
    LastYear = 'LastYear',
    NextYear = 'NextYear',
    Custom = 'Custom',
}

export enum DatePeriodType {
    Custom = 'Custom',
    This = 'This',
    Last = 'Last',
    Next = 'Next',
}

export enum DateUnit {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
}

const customDateRangeSchema = z.object({
    datePeriod: z.literal(DatePeriod.Custom),
    endDate: Validation.Date.Iso,
    startDate: Validation.Date.Iso,
});

const nonCustomDateRangeSchema = z.object({
    datePeriod: z.nativeEnum(DatePeriod).refine((val) => val !== DatePeriod.Custom),
});

export const dateRangeSchema = z.union([customDateRangeSchema, nonCustomDateRangeSchema]);

export type DateRange = z.infer<typeof dateRangeSchema>;

export interface DateRangePickerDropdownProps extends WithFocusTrapProps {
    allowOneDateRange?: boolean;
    calendarService: CalendarService;
    dateRange: DateRange;
    mode?: 'utc' | 'iso';
    onChange: (dateRange: DateRange) => void;
    prefix?: string;
}

export interface PredefinedDateRangeOption {
    label: string;
    value: string;
    withDivider?: boolean;
}

export interface CustomDateRange {
    startDate?: StructuredDate;
    endDate?: StructuredDate;
}

export interface GetDefaultInputValueProps {
    dateRange: DateRange;
    mode: 'iso' | 'utc';
    transform: FieldAdapter;
}
